import stores from "@/storage/stores";
import { ref } from "vue";
import { formatStoreName } from "../store/formatStoreName";
import { fetchCsrf } from "../csrf/fetchCsrf";
import { getUrlBack } from "@/config/constants";
import { jwt } from "@/event/jwt/jwt";
import { isAppleDevice } from "./isAppleDevice";
import { setTokenDevice } from "../jwt/setTokenDevice";

const csrfToken = ref<string | null>(null)

export async function fetchPostAuthorizationCSRFV2(endpoint: string, data: any) {
    try {
        const store = stores.getStoresData()
        let jwtSend
        let refreshToken

        const headers: Record<string, string> = {
            'Content-Type': 'application/json'
        }

        if (isAppleDevice()) {
            if (store && store.name) {
                const storeName = formatStoreName(store.name)
                refreshToken = localStorage.getItem(`${storeName}_refresh_token`)
            } else {
                refreshToken = localStorage.getItem(`refresh_token`)
            }

            jwtSend = jwt.value
            headers['Authorization'] = `Bearer ${jwt.value}`
            headers['X-Refresh-Token'] = refreshToken ?? ''
        }

        await fetchCsrf(csrfToken)

        headers['X-CSRF-TOKEN'] = csrfToken.value ?? ''

        const url = getUrlBack() + "api/" + endpoint

        const res = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: headers,
            body: JSON.stringify(data)
        })

        const response = await res.json()

        setTokenDevice(response)

        return response
    } catch (e) {
    }
}